import type { ReactNode } from 'react';

interface StackHeaderProps {
  onBack: () => void;
  label?: string;
  title?: string;
  aside?: ReactNode;
}

export function StackHeader({ onBack, label, title, aside }: StackHeaderProps) {
  return (
    <div className="sticky top-0 z-10 -mx-[var(--page-gutter)] border-b border-[rgba(26,26,26,0.06)] bg-[rgba(255,251,242,0.88)] px-[var(--page-gutter)] py-3 backdrop-blur-md">
      <div className="flex items-center gap-3">
        <button
          onClick={onBack}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/78 text-[var(--foreground)] shadow-[0_10px_20px_rgba(62,48,23,0.08)]"
          aria-label="Назад"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>

        <div className="min-w-0 flex-1">
          {label && (
            <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[rgba(26,26,26,0.42)]">
              {label}
            </p>
          )}
          {title && <p className="truncate text-[14px] font-semibold text-[var(--foreground)]">{title}</p>}
        </div>

        {aside}
      </div>
    </div>
  );
}
